const convertTextAlignment = (alignEnum: number): 'left' | 'center' | 'right' => {
  let textAlign: 'left' | 'center' | 'right';

  switch (alignEnum) {
    case 0:
      textAlign = 'left';
      break;
    case 1:
      textAlign = 'center';
      break;
    case 2:
      textAlign = 'right';
      break;
    default:
      textAlign = 'left';
  }

  return textAlign;
};

export default convertTextAlignment;
